var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"text-none primaryColor font-weight-medium",attrs:{"text":"","small":"","loading":_vm.fileDownloadLoading},on:{"click":function($event){return _vm.sampleDownloadFileClick()}}},[_c('v-icon',{attrs:{"small":""}},[_vm._v("mdi-download")]),_vm._v(" Download Sample Template for "+_vm._s(_vm.entityName)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }